
angular.module('core', ['policyModule', 'ngIdle', 'ui.bootstrap', 'edxComponents'])
  .config(function (datepickerConfig) {
      // locally setting the showWeeks value is not working so we'll set it globally
      datepickerConfig.showWeeks = false;
  })
  .config(['$logProvider', function($logProvider){
    $logProvider.debugEnabled(false);
  }])
  .config(function($qProvider) { 
    $qProvider.errorOnUnhandledRejections(false); 
  });
